import React, { useEffect, useContext } from 'react'
import Footer from "../components/Footer"
import { VStack, Text, Heading, Box, HStack, Icon, useColorMode } from '@chakra-ui/react'
import Section from '../components/Section'
import loaderContext from "../context/loaderContext";
import Loader from "../components/Loader/Loader"
import about from '../data/about';
import SEOHead from "../components/SEOHead";
import { motion, AnimatePresence } from 'framer-motion'
import { getTokens } from '../config/colorTokens'
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionBox = motion(Box)
const MotionVStack = motion(VStack)

const About = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])

    return (
        <div>
            <SEOHead
                title="About | Prasoon Soni"
                description="Learn more about Prasoon Soni - A passionate software engineer with expertise in full stack development, problem-solving, and building impactful technology solutions."
                path="/about"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                    <Section id="about">
                        <VStack align="stretch" spacing={8} p={4} pb={10}>

                            {/* Hero Section */}
                            <MotionBox
                                variants={heroVariants}
                            >
                                <VStack align="start" spacing={3}>
                                    <Heading w="full">About Me</Heading>
                                    <Text
                                        fontSize={{ base: "md", md: "lg" }}
                                        color={t.textSubtle}
                                        fontWeight="light"
                                        maxW="2xl"
                                    >
                                        A curious builder turning ideas into systems, and engineering into impact.
                                    </Text>
                                    <Box
                                        h="2px"
                                        w="60px"
                                        bgGradient={t.accentGradient}
                                        borderRadius="full"
                                        mt={1}
                                    />
                                </VStack>
                            </MotionBox>

                            {/* Story Cards */}
                            <MotionVStack
                                variants={containerVariants}
                                spacing={4}
                                align="stretch"
                            >
                                {about.map((section, index) => {
                                    const IconComponent = section.icon
                                    return (
                                        <MotionBox
                                            key={index}
                                            variants={itemVariants}
                                            whileHover={{
                                                scale: 1.02,
                                                transition: { type: 'spring', stiffness: 300, damping: 20 }
                                            }}
                                        >
                                            <Box
                                                border="1px"
                                                borderColor={t.borderCard}
                                                borderRadius="10px"
                                                p={4}
                                                backdropFilter="blur(5px)"
                                                cursor="default"
                                            >
                                                <VStack align="start" spacing={3}>
                                                    <HStack spacing={3} align="center">
                                                        <Box
                                                            p={2}
                                                            borderRadius="12px"
                                                            bg={t.accentSoft}
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <Icon
                                                                as={IconComponent}
                                                                color={t.accent}
                                                                boxSize={5}
                                                            />
                                                        </Box>
                                                        <Heading
                                                            fontSize={{ base: "md", md: "lg" }}
                                                            fontWeight="semibold"
                                                        >
                                                            {section.title}
                                                        </Heading>
                                                    </HStack>
                                                    <Text
                                                        fontSize={{ base: "sm", md: "md" }}
                                                        lineHeight="tall"
                                                        color={t.textSecondary}
                                                        textAlign="justify"
                                                    >
                                                        {section.content}
                                                    </Text>
                                                </VStack>
                                            </Box>
                                        </MotionBox>
                                    )
                                })}
                            </MotionVStack>

                        </VStack>
                    </Section>
                    <Footer />
                </MotionVStack>}
            </AnimatePresence>
        </div>
    )
}

export default About
